import { getAutomationsRouteContext } from '@/lib/automations/automationRoutes.js';

const getAutomationRouteRequestedId = ({ pathname, automationType }) => {
  const routeContext = getAutomationsRouteContext(pathname);

  if (routeContext?.type !== automationType) {
    return null;
  }

  return String(routeContext?.id || '').trim() || null;
};

export default getAutomationRouteRequestedId;
